import { openBlock as t, createElementBlock as n, createElementVNode as o } from "vue";
const r = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function l(c, e) {
  return t(), n("svg", r, [...e[0] || (e[0] = [
    o("path", {
      fill: "currentColor",
      d: "M16 13.5q.65 0 1.075-.425T17.5 12t-.425-1.075T16 10.5t-1.075.425T14.5 12t.425 1.075T16 13.5M5 21q-.825 0-1.413-.587A1.93 1.93 0 0 1 3 19V5q0-.825.587-1.413A1.93 1.93 0 0 1 5 3h14q.825 0 1.413.587Q21 4.175 21 5v2.5h-2V5H5v14h14v-2.5h2V19q0 .825-.587 1.413A1.93 1.93 0 0 1 19 21zm8-4q-.825 0-1.412-.587A1.93 1.93 0 0 1 11 15V9q0-.825.588-1.413A1.93 1.93 0 0 1 13 7h7q.825 0 1.413.587Q22 8.175 22 9v6q0 .825-.587 1.413A1.93 1.93 0 0 1 20 17zm7-2V9h-7v6z"
    }, null, -1)
  ])]);
}
const h = { render: l };
export {
  h as default,
  l as render
};
